export default "__VITE_ASSET__CnG5UDwP__"